import { useState, useEffect } from 'react';

const keys = [
  { note: 'C', white: true },
  { note: 'C#', white: false },
  { note: 'D', white: true },
  { note: 'D#', white: false },
  { note: 'E', white: true },
  { note: 'F', white: true },
  { note: 'F#', white: false },
  { note: 'G', white: true },
  { note: 'G#', white: false },
  { note: 'A', white: true },
  { note: 'A#', white: false },
  { note: 'B', white: true },
  { note: 'C2', white: true },
];

// Melody pattern — indices of white keys to "play"
const melody = [0, 2, 4, 5, 7, 9, 11, 12, 11, 9, 7, 5, 4, 2];

const PianoAnimation = () => {
  const [activeKey, setActiveKey] = useState<number | null>(null);
  const [melodyIndex, setMelodyIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const whiteKeyIndex = melody[melodyIndex];
      // Map white key index to actual key index
      const actualIndex = keys.findIndex((k, i) => {
        let whiteCount = 0;
        for (let j = 0; j <= i; j++) {
          if (keys[j].white) whiteCount++;
        }
        return k.white && whiteCount - 1 === whiteKeyIndex;
      });
      setActiveKey(actualIndex);
      setMelodyIndex(m => (m + 1) % melody.length);

      // Release after 250ms
      setTimeout(() => setActiveKey(null), 250);
    }, 400);

    return () => clearInterval(interval);
  }, [melodyIndex]);

  const whiteKeys = keys.filter(k => k.white);

  return (
    <div className="mt-6 mb-2">
      <div className="rounded-lg border border-primary/20 bg-primary/[0.03] overflow-hidden max-w-[300px] shadow-sm">
        {/* Title bar */}
        <div className="flex items-center gap-1.5 px-3 py-2 border-b border-primary/10 bg-primary/[0.04]">
          <span className="w-[7px] h-[7px] rounded-full bg-primary/20" />
          <span className="w-[7px] h-[7px] rounded-full bg-primary/15" />
          <span className="w-[7px] h-[7px] rounded-full bg-primary/10" />
          <span className="text-[10px] text-primary/40 ml-2 select-none tracking-wide">katerinaverbovskaya.com</span>
        </div>

        {/* Piano keyboard */}
        <div className="px-4 h-[82px] flex items-center">
          <div className="relative flex w-full" style={{ height: '48px' }}>
            {/* White keys */}
            {whiteKeys.map((key, i) => {
              const globalIndex = keys.indexOf(key);
              const isActive = globalIndex === activeKey;
              return (
                <div
                  key={key.note}
                  className={`relative flex-1 border border-primary/10 rounded-b-[3px] transition-all duration-200 ${
                    isActive
                      ? 'bg-primary/20 border-primary/30 shadow-[inset_0_-2px_4px_rgba(0,0,0,0.05)]'
                      : 'bg-background/80'
                  }`}
                  style={{ marginRight: i < whiteKeys.length - 1 ? '1px' : '0' }}
                />
              );
            })}

            {/* Black keys — positioned absolutely */}
            {keys.map((key, i) => {
              if (key.white) return null;
              // Position black key between surrounding white keys
              const whitesBefore = keys.slice(0, i).filter(k => k.white).length;
              const leftPercent = (whitesBefore / whiteKeys.length) * 100 - (0.5 / whiteKeys.length) * 100;
              const isActive = i === activeKey;
              return (
                <div
                  key={key.note}
                  className={`absolute top-0 rounded-b-[2px] transition-all duration-200 ${
                    isActive
                      ? 'bg-primary/50'
                      : 'bg-foreground/70'
                  }`}
                  style={{
                    left: `${leftPercent}%`,
                    width: `${(1 / whiteKeys.length) * 70}%`,
                    height: '58%',
                    zIndex: 2,
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PianoAnimation;
